import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

interface ToolItem {
  name: string;
  logo: string;
}

const tools: ToolItem[] = [
  { name: "Selenium", logo: "https://cdn.simpleicons.org/selenium/43B02A" },
  { name: "JMeter", logo: "https://cdn.simpleicons.org/apache/D22128" },
  { name: "Postman", logo: "https://cdn.simpleicons.org/postman/FF6C37" },
  { name: "Cypress", logo: "https://cdn.simpleicons.org/cypress/69D3A7" },
  { name: "Appium", logo: "https://cdn.simpleicons.org/appium/EE376D" },
  { name: "JUnit", logo: "https://cdn.simpleicons.org/junit5/25A162" },
  { name: "TestNG", logo: "https://cdn.simpleicons.org/testinglibrary/E33332" },
  { name: "Jira", logo: "https://cdn.simpleicons.org/jira/0052CC" },
  { name: "LoadRunner", logo: "https://cdn.simpleicons.org/microfocus/0073E6" },
];

const StestTools: React.FC = () => {
  return (
    <section className="wdev-tech" aria-labelledby="stest-tools-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="stest-tools-title" className="wdev-section-head__title">
            Testing Tools &amp; Technologies
          </h2>
        </AnimatedSection>

        <div className="wdev-tech__grid">
          {tools.map((tool, index) => (
            <motion.div
              key={tool.name}
              className="wdev-tech-card"
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
            >
              <div className="wdev-tech-card__logo">
                <img src={tool.logo} alt={`${tool.name} logo`} loading="lazy" />
              </div>
              <span className="wdev-tech-card__name">{tool.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StestTools;
